import React from 'react';
import { Check, X } from 'lucide-react';
export function ForWho() {
  return <section className="py-16 md:py-24 bg-[#FAF8F5]" data-id="element-79">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-80">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-81">
          {/* Is For */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#C4705A]" data-id="element-82">
            <h3 className="font-serif text-2xl font-bold text-[#2D2A26] mb-6 flex items-center gap-3" data-id="element-83">
              <span className="bg-[#C4705A]/10 text-[#C4705A] p-1.5 rounded-full" data-id="element-84">
                <Check className="w-5 h-5" data-id="element-85" />
              </span>
              Es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-86">
              <li className="flex items-start gap-3 text-[#2D2A26]/80" data-id="element-87">
                <Check className="w-5 h-5 text-[#C4705A] mt-0.5 flex-shrink-0" data-id="element-88" />
                <span data-id="element-89">
                  Tienes dolor leve–moderado recurrente en cuello o espalda.
                </span>
              </li>
              <li className="flex items-start gap-3 text-[#2D2A26]/80" data-id="element-90">
                <Check className="w-5 h-5 text-[#C4705A] mt-0.5 flex-shrink-0" data-id="element-91" />
                <span data-id="element-92">
                  Vives ocupada y te cuesta sostener rutinas largas de
                  ejercicio.
                </span>
              </li>
              <li className="flex items-start gap-3 text-[#2D2A26]/80" data-id="element-93">
                <Check className="w-5 h-5 text-[#C4705A] mt-0.5 flex-shrink-0" data-id="element-94" />
                <span data-id="element-95">
                  Quieres algo <strong data-id="element-96">seguro, simple y repetible</strong> que
                  puedas hacer en casa.
                </span>
              </li>
              <li className="flex items-start gap-3 text-[#2D2A26]/80" data-id="element-97">
                <Check className="w-5 h-5 text-[#C4705A] mt-0.5 flex-shrink-0" data-id="element-98" />
                <span data-id="element-99">
                  Buscas alivio real sin depender de medicamentos constantes.
                </span>
              </li>
            </ul>
          </div>

          {/* Is Not For */}
          <div className="bg-[#2D2A26]/5 p-8 rounded-2xl border border-[#2D2A26]/10" data-id="element-100">
            <h3 className="font-serif text-2xl font-bold text-[#2D2A26] mb-6 flex items-center gap-3" data-id="element-101">
              <span className="bg-[#2D2A26]/10 text-[#2D2A26] p-1.5 rounded-full" data-id="element-102">
                <X className="w-5 h-5" data-id="element-103" />
              </span>
              No es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-104">
              <li className="flex items-start gap-3 text-[#2D2A26]/70" data-id="element-105">
                <X className="w-5 h-5 text-[#2D2A26]/40 mt-0.5 flex-shrink-0" data-id="element-106" />
                <span data-id="element-107">
                  Tienes una lesión aguda reciente o post-operatorio sin
                  autorización médica.
                </span>
              </li>
              <li className="flex items-start gap-3 text-[#2D2A26]/70" data-id="element-108">
                <X className="w-5 h-5 text-[#2D2A26]/40 mt-0.5 flex-shrink-0" data-id="element-109" />
                <span data-id="element-110">
                  Presentas síntomas graves como entumecimiento intenso o
                  pérdida de fuerza.
                </span>
              </li>
              <li className="flex items-start gap-3 text-[#2D2A26]/70" data-id="element-111">
                <X className="w-5 h-5 text-[#2D2A26]/40 mt-0.5 flex-shrink-0" data-id="element-112" />
                <span data-id="element-113">
                  Buscas una rutina de fitness intensa para ganar masa muscular.
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-114">
          <p className="font-serif text-xl italic text-[#2D2A26]" data-id="element-115">
            "Si sigues viviendo igual y solo 'estiras cuando te acuerdas', el
            dolor va a seguir ganando por cansancio. Este método le enseña a tu
            cuerpo lo contrario."
          </p>
        </div>
      </div>
    </section>;
}